const sampleSongs = [
  {
    id: 1,
    title: "Blinding Lights",
    artist: "The Weeknd",
    album: "After Hours",
    genre: "Pop",
    duration: 203,
    coverUrl: "https://i.scdn.co/image/ab67616d0000b273c5649add07ed3720be9d5526",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    isFavorite: false
  },
  {
    id: 2,
    title: "Levitating",
    artist: "Dua Lipa",
    album: "Future Nostalgia",
    genre: "Pop",
    duration: 217,
    coverUrl: "https://i.scdn.co/image/ab67616d0000b273bd26ede1ae69327010d49946",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
    isFavorite: true
  },
  {
    id: 3,
    title: "Save Your Tears",
    artist: "The Weeknd",
    album: "After Hours",
    genre: "Pop",
    duration: 215,
    coverUrl: "https://i.scdn.co/image/ab67616d0000b273c5649add07ed3720be9d5526",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
    isFavorite: false
  },
  {
    id: 4,
    title: "Good 4 U",
    artist: "Olivia Rodrigo",
    album: "SOUR",
    genre: "Pop Rock",
    duration: 178,
    coverUrl: "https://i.scdn.co/image/ab67616d0000b273a91c10fe9472d9bd89802e5a",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
    isFavorite: false
  },
  {
    id: 5,
    title: "Stay",
    artist: "The Kid LAROI & Justin Bieber",
    album: "F*CK LOVE 3: OVER YOU",
    genre: "Pop",
    duration: 141,
    coverUrl: "https://i.scdn.co/image/ab67616d0000b273f2f2d0d181fc6b69b8a7f2c5",
    audioUrl: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3",
    isFavorite: true
  },
  {
    id: 6,
    title: "Midnight Dreams",
    artist: "Luna Echo",
    album: "Starlight",
    genre: "Electronic",
    duration: 237,
    coverUrl: "https://images.unsplash.com/photo-1614149162883-504ce4d13909?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bXVzaWMlMjBhbGJ1bXxlbnwwfHwwfHx8MA%3D%3D&w=1000&q=80",
    audioUrl: "https://assets.mixkit.co/music/preview/mixkit-tech-house-vibes-130.mp3",
    isFavorite: false,
    releaseDate: "2023-05-15"
  },
  {
    id: 7,
    title: "Ocean Waves",
    artist: "Aqua Drift",
    album: "Deep Blue",
    genre: "Ambient",
    duration: 185,
    coverUrl: "https://images.unsplash.com/photo-1557672172-298e090bd0f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8b2NlYW4lMjBibHVlfGVufDB8fDB8fHww&w=1000&q=80",
    audioUrl: "https://assets.mixkit.co/music/preview/mixkit-dreaming-big-31.mp3",
    isFavorite: false,
    releaseDate: "2023-02-10"
  },
  {
    id: 8,
    title: "Neon Streets",
    artist: "Cyber Punk",
    album: "Future City",
    genre: "Synthwave",
    duration: 210,
    coverUrl: "https://images.unsplash.com/photo-1563089145-599997674d42?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bmVvbiUyMGNpdHl8ZW58MHx8MHx8fDA%3D&w=1000&q=80",
    audioUrl: "https://assets.mixkit.co/music/preview/mixkit-hip-hop-02-614.mp3",
    isFavorite: true,
    releaseDate: "2023-03-22"
  },
  {
    id: 9,
    title: "Mountain High",
    artist: "Nature Sounds",
    album: "Wilderness",
    genre: "Ambient",
    duration: 195,
    coverUrl: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bW91bnRhaW58ZW58MHx8MHx8fDA%3D&w=1000&q=80",
    audioUrl: "https://assets.mixkit.co/music/preview/mixkit-serene-view-443.mp3",
    isFavorite: false,
    releaseDate: "2023-01-05"
  },
  {
    id: 10,
    title: "Desert Wind",
    artist: "Nomad",
    album: "Sands of Time",
    genre: "World",
    duration: 228,
    coverUrl: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZGVzZXJ0fGVufDB8fDB8fHww&w=1000&q=80",
    audioUrl: "https://assets.mixkit.co/music/preview/mixkit-spirit-of-the-desert-494.mp3",
    isFavorite: false,
    releaseDate: "2023-04-18"
  }
];

export default sampleSongs;